import { SERVICES_LIST_ACTION,ADD_SERVICES_ACTION,UPDATE_SERVICES_ACTION } from "../Actions/ServicesListAction";



const initialstate ={servicesList:[]};

const servicesListReducer = (state = initialstate,action) =>{
    switch (action.type) {
        case SERVICES_LIST_ACTION:
            return {
                ...state,
                servicesList: action.payload,
            };
        case ADD_SERVICES_ACTION:
            return {
                ...state,
                servicesList: [...state.servicesList, action.payload],  
            };
        case UPDATE_SERVICES_ACTION:
            return {
                ...state,
                servicesList: state.servicesList.map(profile =>
                    profile.id === action.payload.id
                        ? { ...action.payload } 
                        : profile
                ),
            };


        default:
            return state
    }
}


export default servicesListReducer;

